import React from 'react';
import { dateToTimezone, empty } from './../../../utils';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import Pagination from './../../Pagination';
import numeral from 'numeral';

const Table = React.memo((props) => {
    let permissions = [];
    if (props.user && props.user.uth_permissions != null) {
        permissions = JSON.parse(props.user.uth_permissions);
    }

    const hendleDownloadPdf = (url) => {
        window.open(url);
    };

    const handleShowApproveModal = (id) => {
        props.setIdModal(id);
        props.showApproveModal();
    };

    const handleShowRejectModal = (id) => {
        props.setIdModal(id);
        props.showRejectModal();
    };

    const handleShowInfoModal = (id) => {
        props.setIdModal(id);
        props.showInfoModal();
    };

    const handleShowShippingModal = (id) => {
        let selectedOrder = null;
        for (let i = 0; i < props.orders.length; i++) {
            if (parseInt(props.orders[i].id) === parseInt(id)) {
                selectedOrder = props.orders[i];
                break;
            }
        }

        props.setIdModal(id);
        props.setTrackingNumber(selectedOrder.tracking_number);
        props.setShipped(selectedOrder.shipped);
        props.setShippingMethod(selectedOrder.shipping_method);
        props.setShippingQuantity(selectedOrder.shipping_quantity);
        props.setShippingWeight(selectedOrder.shipping_weight);
        props.setShippingNumPackages(selectedOrder.shipping_num_packages);
        props.showShippingModal();
    };

    const handleShowPackingSlipModal = (id) => {
        let selectedProduct = null;
        for (let i = 0; i < props.orders.length; i++) {
            if (parseInt(props.orders[i].id) === parseInt(id)) {
                selectedProduct = props.orders[i];
                break;
            }
        }

        props.setIdModal(id);
        props.setTrackingNumber(selectedProduct.tracking_number);
        props.setShipped(selectedProduct.shipped);
        props.setShippingMethod(selectedProduct.shipping_method);
        props.setShippingQuantity(selectedProduct.shipping_quantity);
        props.setShippingWeight(selectedProduct.shipping_weight);
        props.setShippingNumPackages(selectedProduct.shipping_num_packages);
        props.setPackingSlipMessage(selectedProduct.packing_slip_message);
        props.fetchPackingSlipData();
        props.showPackingSlipModal();
    };

    const handleReorder = (id) => {
        props.reorderProduct(id, props.history);
    };

    const handleSort = (column, type) => {
        props.setSort(column, type, props.type);
    };

    const renderHeader = (label, field) => {
        let sortType = 'asc';
        let sortIcon = <i className="fas fa-sort" />;
        if (props.sort.column === field) {
            if (props.sort.type === 'desc') {
                sortIcon = <i className="fas fa-sort-down" />;
                sortType = 'asc';
            } else {
                sortIcon = <i className="fas fa-sort-up" />;
                sortType = 'desc';
            }
        }

        return <div onClick={handleSort.bind(this, field, sortType)}>{label} {sortIcon}</div>
    };

    const handleCheckScTicketCheckbox = (order) => {
        props.checkScTicketCheckbox(order);
    };

    const renderOrders = () => {
        let columns = 13;
        if (props.type === 'pending') {
            columns = 12;
        } else if (props.type === 'approved') {
            columns = 16;
        }

        if (props.fetching) {
            return (
                <tr>
                    <td colSpan={columns}><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (props.orders.length === 0) {
            return (
                <tr>
                    <td colSpan={columns}>No results</td>
                </tr>
            );
        }

        return props.orders.map((order) => {
            let cardFor = 'N/A';
            let quantity = numeral(order.quantity).format('0,0');
            if (order['variables'] && order['variables'] !== '') {
                let json = JSON.parse(order['variables']);
                if (json.name && json.name !== '') {
                    cardFor = json.name;
                }
                if (json.templateCode && ['p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10', 'p9t11', 'p9t12', 'p9t13', 'p9t14', 
                    'p9t15', 'p9t16', 'p9t17', 'p9t18', 'p9t19', 'p9t20', 'p9t21', 'p9t22', 'p9t23'].includes(json.templateCode)) {
                    if (json.name && json.name !== '') {
                        cardFor = json.name;
                    } else if (json.firstName && json.firstName !== '' && json.lastName && json.lastName !== '') {
                        cardFor = json.firstName + ' ' + json.lastName;
                    }
                }

                if (json.staticTemplateCode) {
                    quantity += (order.quantity > 1 ? ' bundles' : ' bundle');
                    quantity += ' (' + numeral(order.pieces_per * order.quantity).format('0,0') + ' pieces)';
                }

                if (parseInt(json.staticTemplateCode) === 647) {
                    quantity = order.quantity;
                } else if (parseInt(json.staticTemplateCode) === 652) {
                    quantity = order.quantity;
                }
            }

            let approveIcon = null;
            let rejectIcon = null;
            if (props.type === 'pending' && permissions.includes('orders-action')) {
                approveIcon = (
                    <Tooltip title="Approve Order" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-check-circle approve-icon" onClick={handleShowApproveModal.bind(this, order.uthealth_order_id)} />
                    </Tooltip>
                );
                rejectIcon = (
                    <Tooltip title="Reject Order" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-times-circle reject-icon" onClick={handleShowRejectModal.bind(this, order.uthealth_order_id)} />
                    </Tooltip>
                );
            }
            if (parseInt(order.type) === 2) {
                approveIcon = null;
                rejectIcon = null;
            }

            let actionByTd = null;
            if (props.type !== 'pending') {
                actionByTd = <td>{order.approval_rejected_by_name}</td>;
            }

            let createSCTicket = null;
            if (props.type === 'approved' && permissions.includes('orders-sc-ticket')) {
                let scIconClassName = '';
                if (order.sc_ticket_exists) {
                    scIconClassName = ' sc-exists';
                }

                createSCTicket = (
                    <Tooltip title="Create SC Ticket" position="top" arrow size="small" className="action-tooltip">
                        <i className={'fas fa-sign-in-alt sc-icon' + scIconClassName} onClick={props.handleShowSCTicketModal.bind(this, order.id)} />
                    </Tooltip>
                );
            }

            if (order.product_type === 'Brochures & Flyers') {
                const variables = JSON.parse(order['variables']);
                if (parseInt(variables['brochureTemplateCode']) === 1) {
                    quantity = numeral(order.quantity).format('0,0') + (order.quantity > 1 ? ' bundles' : ' bundle');
                    quantity += ' (' + numeral(250 * order.quantity).format('0,0') + ' pieces)';
                } else if (parseInt(variables['brochureTemplateCode']) === 2) {
                    quantity = numeral(order.quantity).format('0,0');
                } else if (parseInt(variables['brochureTemplateCode']) === 8) {
                    quantity = numeral(order.quantity).format('0,0') + (order.quantity > 1 ? ' bundles' : ' bundle');
                    quantity += ' (' + numeral(50 * order.quantity).format('0,0') + ' pieces)';
                }
            }

            let approvedDateTd = null;
            let trackingNumberTd = null;
            let scTd = null;
            if (props.type === 'approved') {
                approvedDateTd = <td>{dateToTimezone(order.approved_date, 'MM/DD/YYYY')}</td>;
                trackingNumberTd = <td>{order.tracking_number ? order.tracking_number : '-'}</td>;
                scTd = <td><a href={'https://www.stagecoachview.com/tracking/' + order.pqt_tracking_id} target="_blank" rel="noopener noreferrer">{order.pqt_tracking_id}</a></td>;
            }

            if (props.cxmlData.buyer_cookie != null && ['pamela.h.butler@uth.tmc.edu', 'nicole.l.brown@uth.tmc.edu',
                'robina.a.philipose@uth.tmc.edu'].includes(props.cxmlData.email.toLowerCase())) {
                const variables = JSON.parse(order['variables']);
                trackingNumberTd = <td>{variables.start} - {variables.end}</td>;
            }

            let shippingIcon = null;
            let packingSlipIcon = null;
            if (props.type === 'approved' && permissions.includes('orders-shipping')) {
                shippingIcon = (
                    <Tooltip title="Shipping Information" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-truck shipping-icon" onClick={handleShowShippingModal.bind(this, order.id)} />
                    </Tooltip>
                );
            }
            if (props.type === 'approved' && permissions.includes('orders-packing-slip')) {
                packingSlipIcon = (
                    <Tooltip title="Packing Slip" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-box-open shipping-icon" onClick={handleShowPackingSlipModal.bind(this, order.id)} />
                    </Tooltip>
                );
            }

            let pdfUrl = order.pdf_url;
            if (!empty(order.final_pdf_url)) {
                pdfUrl = order.final_pdf_url;
            }
            if (order.product_type === 'MyUTHealth') {
                pdfUrl = order.preview_url;
                if (!empty(order.pdf_url) && order.pdf_url !== '-') {
                    pdfUrl = order.pdf_url;
                }
            }
            if (props.user && [3, 7].includes(parseInt(props.user.uth_type)) && order.product_type === 'MyUTHealth') {
                const variables = JSON.parse(order['variables']);
                if (parseInt(variables['myuthealthTemplateCode']) === 11 && variables['language'] === 'English') {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+Parent_Guardian+Brochure-English-Print-bleed.pdf';
                } else if (parseInt(variables['myuthealthTemplateCode']) === 11 && variables['language'] === 'Spanish') {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+Parent_Guardian+Brochure-Spanish-Print-bleed.pdf';
                } else if (parseInt(variables['myuthealthTemplateCode']) === 11 && variables['language'] === 'Vietnamese') {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+Parent_Guardian+Brochure-Vietnames-Print-bleed.pdf';
                } else if (parseInt(variables['myuthealthTemplateCode']) === 11 && variables['language'] === 'Chinese') {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+ParentGuardian+Brochure-Chinese-Print-bleed.pdf';
                } else if (parseInt(variables['myuthealthTemplateCode']) === 11 && variables['language'] === 'Arabic') {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/myuthealth-images/UTPM-9045_MyUTHealth+ParentGuardian+Brochure-Arabic-Print-bleed.pdf';
                } else if (parseInt(variables['myuthealthTemplateCode']) === 10) {
                    pdfUrl = order.pdf_url;
                }
            }
            if (props.user && [3, 7].includes(parseInt(props.user.uth_type)) && order.product_type === 'Brochures & Flyers') {
                const variables = JSON.parse(order['variables']);
                if (parseInt(variables['brochureTemplateCode']) === 3) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-1001CO-PR_R-English.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 4) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-1001CO-PR_R-Spanish.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 5) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-1003CO-ComplaintsHMONotice-English-Spanish.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 6) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/645619_UTP-Translation-Services-Poster.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 8) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-images/Purple_Art_Exhibit_Pamphlet_Trifold_Brochure-print-file.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 9) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/No_Surprise_Billing_with_bleed_12x18-final.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 10) {
                    pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/brochures-files/UT_Good_Faith_Estimate_Notice_w_qr_codes.pdf';
                } else if (parseInt(variables['brochureTemplateCode']) === 12 && empty(order.final_pdf_url)) {
                    pdfUrl = null;
                }
            }

            let pdfIcon = null;
            if (permissions.includes('orders-pdf') && pdfUrl != null) {
                pdfIcon = (
                    <Tooltip title="View PDF" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-file-pdf pdf-icon" onClick={hendleDownloadPdf.bind(this, pdfUrl)} />
                    </Tooltip>
                );
            }

            const variables = JSON.parse(order['variables']);
            if (props.user && ![3, 7].includes(parseInt(props.user.uth_type)) && variables['templateCode'] === 'p17t3') {
                pdfIcon = (
                    <Tooltip title="View PDF" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-file-pdf pdf-icon" onClick={hendleDownloadPdf.bind(this, order.preview_url)} />
                    </Tooltip>
                );
            }

            let reorderIcon = null;
            if (permissions.includes('orders-reorder')) {
                reorderIcon = (
                    <Tooltip title="Re-Order Product" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-cart-plus" onClick={handleReorder.bind(this, order.id)} />
                    </Tooltip>
                );
            }

            const uthUnisexVariables = JSON.parse(order['variables']);
            if (parseInt(uthUnisexVariables['apparelTemplateCode']) === 125) {     // UTH Unisex
                reorderIcon = null;
            }

            const index = props.scTicketSelectedItems.findIndex((item) => parseInt(item.id) === parseInt(order.id));

            let scTicketCheckboxDisabled = true;
            let scTicketCheckboxChecked = true;
            if (empty(order.pqt_tracking_id)) {
                scTicketCheckboxDisabled = false;
                scTicketCheckboxChecked = index !== -1;
            }

            let scTicketCheckbox = null;
            if (props.type === 'approved' && permissions.includes('orders-sc-ticket')) {
                scTicketCheckbox = (
                    <input
                        type="checkbox"
                        disabled={scTicketCheckboxDisabled}
                        checked={scTicketCheckboxChecked}
                        onClick={handleCheckScTicketCheckbox.bind(this, order)}
                    />
                );
            }

            let scTicketColumn = null;
            if (props.type === 'approved' && permissions.includes('orders-sc-ticket')) {
                scTicketColumn = (
                    <td className="text-center">
                        {scTicketCheckbox}
                    </td>
                );
            }

            let additionalPdf = null;
            if (!empty(order.additional_pdf_url) && permissions.includes('orders-pdf')) {
                additionalPdf = (
                    <Tooltip title="View Envelope PDF" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-envelope pdf-icon" onClick={hendleDownloadPdf.bind(this, order.additional_pdf_url)} />
                    </Tooltip>
                );
            }

            let orderDetailsIcon = null;
            if (permissions.includes('orders-info')) {
                orderDetailsIcon = (
                    <Tooltip title="Order Details" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-info-circle info-icon" onClick={handleShowInfoModal.bind(this, order.id)} />
                    </Tooltip>
                );
            }

            return (
                <tr key={order.id}>
                    <td>{order.uthealth_order_id}</td>
                    <td style={{ width: 45 }}>{order.part_number}/{order.total_parts}</td>
                    <td>{order.billPo}</td>
                    {scTd}
                    <td>{quantity}</td>
                    <td>{cardFor}</td>
                    <td>{dateToTimezone(order.created_at, 'MM/DD/YYYY')}</td>
                    <td>{order.product_type}</td>
                    <td>{order.order_type}</td>
                    <td>{order.ordered_by_name}</td>
                    {actionByTd}
                    {approvedDateTd}
                    <td>{numeral(order.total_price).format('$0,0.00')}</td>
                    {trackingNumberTd}
                    {scTicketColumn}
                    <td>
                        <div className="actions">
                            {createSCTicket}
                            {pdfIcon}
                            {additionalPdf}
                            {reorderIcon}
                            {orderDetailsIcon}
                            {approveIcon}
                            {rejectIcon}
                            {packingSlipIcon}
                            {shippingIcon}
                        </div>
                    </td>
                </tr>
            );
        });
    };

    let actionByTh = null;
    let approvedDateTh = null;
    let dateColumnName = 'Date';
    let trackingNumberTh = null;
    let scTh = null;
    if (props.type === 'approved') {
        actionByTh = (
            <th>
                <span className="sort-column">{renderHeader('Approved By', 'action_by')}</span>
            </th>
        );
        approvedDateTh = (
            <th>
                <span className="sort-column">{renderHeader('Approved Date', 'approved_date')}</span>
            </th>
        );
        trackingNumberTh = (
            <th>
                <span className="sort-column">{renderHeader('Tracking Number', 'tracking_number')}</span>
            </th>
        );
        scTh = (
            <th>
                <span className="sort-column">{renderHeader('SC #', 'pqt_tracking_id')}</span>
            </th>
        );

        dateColumnName = 'Ordered Date';

        if (props.cxmlData.buyer_cookie != null && ['pamela.h.butler@uth.tmc.edu', 'nicole.l.brown@uth.tmc.edu',
            'robina.a.philipose@uth.tmc.edu'].includes(props.cxmlData.email.toLowerCase())) {
            trackingNumberTh = (
                <th>
                    <span className="sort-column">Control Numbers</span>
                </th>
            );
        }
    } else if (props.type === 'rejected') {
        actionByTh = (
            <th>
                <span className="sort-column">{renderHeader('Rejected By', 'action_by')}</span>
            </th>
        );
    }

    let scTicketHeader = null;
    if (props.type === 'approved' && permissions.includes('orders-sc-ticket')) {
        scTicketHeader = <th style={{ width: 60 }} className="text-center">Create SC Ticket</th>;
    }

    return (
        <div className="table-container">
            <table className="table table-sm table-hover table-striped">
                <thead>
                    <tr>
                        <th>
                            <span className="sort-column">{renderHeader('Order #', 'uthealth_order_id')}</span>
                        </th>
                        <th>Part</th>
                        <th>
                            <span className="sort-column">{renderHeader('PO #', 'billPo')}</span>
                        </th>
                        {scTh}
                        <th>
                            <span className="sort-column">{renderHeader('Qty', 'quantity')}</span>
                        </th>
                        <th>
                            Card For
                        </th>
                        <th>
                            <span className="sort-column">{renderHeader(dateColumnName, 'created_at')}</span>
                        </th>
                        <th>
                            <span className="sort-column">{renderHeader('Product', 'product_type')}</span>
                        </th>
                        <th>
                            <span className="sort-column">{renderHeader('Order Type', 'order_type')}</span>
                        </th>
                        <th>
                            <span className="sort-column">{renderHeader('Ordered By', 'ordered_by_name')}</span>
                        </th>
                        {actionByTh}
                        {approvedDateTh}
                        <th>
                            <span className="sort-column">{renderHeader('Total', 'total_price')}</span>
                        </th>
                        {trackingNumberTh}
                        {scTicketHeader}
                        <th style={{ width: 230 }}></th>
                    </tr>
                </thead>
                <tbody>{renderOrders()}</tbody>
            </table>
            <Pagination
                pagination={props.pagination}
                setActivePage={props.setActivePage}
            />
        </div>
    );
});

export default Table;
